export const paymentMethods = {
    CARD: {value: 'card'},
    BANK_SLIP: {value: 'bankSlip'},
    BANK_TRANSFER: {value: 'bankTransfer'},
    VIRTUAL_DEBIT_ELO: {value: 'virtualDebitElo'},
    PIX: {value: 'pix'},
}
